import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementAudienceSyncPlatformAdAccountsAdAccountIdResult = objectOf({
  data: objectOf({
    id: string,
    name: string,
    custom_audiences: arrayOf(
      objectOf({
        id: string,
        name: string,
        data_type: string,
        status: nullOrUndefined,
      })
    ),
    additional_data: objectOf({
      set_mobile_ad_ids: arrayOf(nullOrUndefined),
    }),
  }),
});
